/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_AvgInputs */

const en_ui_rail_avg = /** @type {(inputs: Ui_Rail_AvgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avg`)
};

const de_ui_rail_avg = /** @type {(inputs: Ui_Rail_AvgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø`)
};

/**
* | output |
* | --- |
* | "avg" |
*
* @param {Ui_Rail_AvgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_avg = /** @type {((inputs?: Ui_Rail_AvgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_AvgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_avg(inputs)
	return de_ui_rail_avg(inputs)
});